/**
 * Employee Portal — Saudi defaults, formatters, leave/EOSB helpers.
 * Re-exports portal utilities for use outside page components.
 */
import { calculateEOSBProvision } from '../../pages/salaires/utils/payrollSaudiFormat';

export {
  SAUDI_LEAVE_ENTITLEMENTS,
  SAUDI_LEAVE_TYPES,
  computeSaudiLeaveBalances,
  normalizeLeaveType,
  normalizeLeaveStatus,
  normalizeServiceStatus,
  normalizeRequestType,
  normalizePriority,
  normalizeDocumentCategory,
  getLeaveTypeLabel,
  getRequestTypeLabel,
  formatPortalDate,
  getPortalHijriPref,
  setPortalHijriPref,
} from '../../pages/employee-portal/employeePortalShared';

export {
  formatPortalMoney,
  formatPortalHijriDate,
  formatPortalDateWithHijri,
  resolveOptionLabel,
} from '../../pages/employee-portal/employeePortalSaudiFormat';

export {
  SAUDI_ANNUAL_LEAVE_DAYS,
  SAUDI_SICK_LEAVE_DAYS,
  SAUDI_PROBATION_DAYS,
  formatHrDate,
  isHrEmployeeSaudi,
} from './hrSaudiDefaults';

export {
  getBrandPhonePlaceholder,
  normalizeBrandPhone,
  isBrandPhoneValid,
  SAUDI_PHONE_PREFIX,
} from './brandCountry';

export { formatBrandMoney, getBrandDefaultCurrency, getBrandCurrencySuffix } from './brandCurrency';

/** Monthly EOSB accrual for portal dashboard (SAR). */
export function computePortalEosbAccrual(basicSalary) {
  const basic = parseFloat(basicSalary) || 0;
  if (basic <= 0) return 0;
  return calculateEOSBProvision(basic);
}

/** Days until expiry (negative if already expired). */
export function daysUntilExpiry(dateInput) {
  if (!dateInput) return null;
  const d = new Date(dateInput);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.ceil((d - today) / (1000 * 60 * 60 * 24));
}
